import { GET_ACCESS_TOKENS } from "constants/accessTokens";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_ACCESS_TOKENS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
